module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('tr', [_c('td', [_vm._v("Date:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.formatDate(_vm.rowData.date)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Invoice #:")]), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.rowData.invoiceNo))]), (_vm.isDesktop) ? _c('span', [_vm._v(" " + _vm._s(_vm.rowData.invoiceType))]) : _vm._e()]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('download-button', {
    attrs: {
      "url": 'print/invoice/' + _vm.rowData.id + '/excel',
      "icon": "fa fa-file-excel",
      "size": "mini",
      "type": "primary"
    }
  }, [_vm._v("Excel")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Term:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rowData.terms))]), _vm._v(" days")])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('tr', [_c('td', [_vm._v("To:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rowData.to.name))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Line Items:")]), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 15
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.rowData.lines))])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 9
    }
  }, [_c('download-button', {
    attrs: {
      "url": 'print/invoice/' + _vm.rowData.id,
      "icon": "fa fa-file-pdf",
      "size": "mini",
      "type": "danger"
    }
  }, [_vm._v("Print")])], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("From:")]), _c('td', [_c('strong', [_vm._v(_vm._s(_vm.rowData.from.name))])])])])]), _vm._v(" "), _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 12,
      "md": 8
    }
  }, [_c('table', {
    staticClass: "el-table"
  }, [_c('tr', [_c('td', [_vm._v("Total")]), _c('td', [_c('strong', {
    staticClass: "text-primary"
  }, [_vm._v(_vm._s(this.formatNumber(_vm.rowData.total)))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Paid")]), _vm._v(" "), _c('td', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 14
    }
  }, [_c('strong', {
    staticClass: "text-success"
  }, [_vm._v(_vm._s(this.formatNumber(_vm.rowData.totalPaid)))]), _vm._v(" \n              ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('invoice-payment', {
    attrs: {
      "row-data": _vm.rowData,
      "button-type": "round"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("O/S")]), _c('td', [_c('strong', {
    staticClass: "text-warning"
  }, [_vm._v(_vm._s(this.formatNumber(_vm.rowData.total - _vm.rowData.totalPaid)))])])])])])], 1), _vm._v(" "), _c('data-table', {
    attrs: {
      "title": "Invoice Items",
      "table-ref": "lineItems",
      "url": 'invoice/' + _vm.rowData.id + '/items',
      "fields": _vm.fields,
      "sort-field": "id",
      "add-props": {
        items: _vm.checked
      },
      "add-action": _vm.payAll,
      "checked-callback": _vm.itemsChecked,
      "detail-component": "item-payment-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "odue",
      fn: function(props) {
        return [_c('el-row', {
          staticStyle: {
            "width": "10rem"
          }
        }, [_c('el-col', {
          attrs: {
            "align": "left",
            "span": _vm.isSuper() ? 17 : 24,
            "offset": 1
          }
        }, [_c('span', {
          domProps: {
            "innerHTML": _vm._s(_vm.formatDue(props.rowData.totalPaid, props.rowData.total))
          }
        })]), _vm._v(" "), (_vm.isSuper()) ? _c('el-col', {
          attrs: {
            "align": "right",
            "span": 2,
            "offset": 4
          }
        }, [(!props.rowData.paid) ? _c('el-button', {
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "fa fa-trash-alt"
          },
          on: {
            "click": function($event) {
              return _vm.deleteLine(props.rowData.id, props.rowData.details)
            }
          }
        }) : _vm._e()], 1) : _vm._e()], 1)]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7bd27c55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/finance/invoice/InvoiceDetails.vue
// module id = 1655
// module chunks = 0